import React from 'react'
import ConfirmIcon from 'assets/icons/confirm-icon'
import RejectIcon from 'assets/icons/reject-icon'
import { reassessmentTriggerReasons } from 'constants/reassessmentTriggerReasons'

export const getRejectReasonNames = (item) => {
  return (item.triggerReasonId || []).map((element) => {
    return reassessmentTriggerReasons.find((elementId) => elementId.id === element)?.name
  }).filter(Boolean)
}

export const getActionMenuItems = ({ isApprovedBySecretariat, onReject, onConfirm }) => {
  if (isApprovedBySecretariat) {
    return [{
      icon: <RejectIcon />,
      title: 'rejectEcosystem',
      onClick: onReject,
      isDestructive: true
    }]
  }

  return [{
    icon: <ConfirmIcon />,
    title: 'confirmEcosystem',
    onClick: onConfirm
  }]
}

export const getReassessmentActionId = (oldTriggers, newTriggers) => {
  if (oldTriggers) return 'reassess'
  if (newTriggers) return 'assess'
  return 'reassess'
}

